import styled from "styled-components";

export const Container = styled.div`

   display: flex;
    border-bottom: 1px solid #e0e0e0;
    /* margin-bottom: 20px; */
    `;

export const SubModulesNavHeader = styled.nav`
    display: flex;
    overflow-x: auto;
    gap: 4px;
    width: 100%;
    justify-content: flex-start;
`;

export const Button = styled.div<{ active?: boolean }>`
    padding: 12px 20px;
    border: none;

    cursor: pointer;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-right: 2px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    position: relative;

    background: ${({ active }) => active ? "#20a45a" : "#f8f9fa"};
    color: ${({ active }) => active ? "#fff" : "#666"};

    span {
        color: ${({ active }) => active ? "#fff" : "#666"};
    }

    svg {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 14px;
        cursor: pointer;
    }

`;